import { render, staticRenderFns } from "./Supervised.vue?vue&type=template&id=519bd6b5&scoped=true"
import script from "./Supervised.vue?vue&type=script&lang=js"
export * from "./Supervised.vue?vue&type=script&lang=js"
import style0 from "./Supervised.vue?vue&type=style&index=0&id=519bd6b5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bd6b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519bd6b5')) {
      api.createRecord('519bd6b5', component.options)
    } else {
      api.reload('519bd6b5', component.options)
    }
    module.hot.accept("./Supervised.vue?vue&type=template&id=519bd6b5&scoped=true", function () {
      api.rerender('519bd6b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialists/dipensation-request/components/Supervised.vue"
export default component.exports